import { render, staticRenderFns } from "./MyProjectsOfferDetailActions.vue?vue&type=template&id=b19cc066&scoped=true"
import script from "./MyProjectsOfferDetailActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsOfferDetailActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsOfferDetailActions.vue?vue&type=style&index=0&id=b19cc066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19cc066",
  null
  
)

export default component.exports